// extracted by mini-css-extract-plugin
export default {"tooltip-info":"Form_tooltip-info__yiLir","mobile":"Form_mobile__fF1hY","open":"Form_open__v30FV","tooltip-icon":"Form_tooltip-icon__IVr7V","form-link":"Form_form-link__-wFEC"};